function Error() {
  return (
    <div className="flex flex-1 justify-center items-center  text-3xl text-richblack-800 
    bg-richblue-300">
      Error 404 - Page Not Found
    </div>
  );
}

export default Error;